import { ICollaborationRegistry, ICollaborationRepository, ILinkedDocumentRepository } from "../../../domain/collaboration";
import { CollaborationRepository, LinkedDocumentRepository } from ".";

export class CollaborationRegistry implements ICollaborationRegistry {
  constructor(private _getToken: () => string) {
  }
  
  public getCollaborationRepository(): ICollaborationRepository {
    return new CollaborationRepository(this._getToken);
  }
  
  public getLinkedDocumentRepository(): ILinkedDocumentRepository {
    return new LinkedDocumentRepository(this._getToken);
  }
}
